if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-bar__wrapper").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-bar__wrapper").classList.add("hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
    
        this.errorMessageWrapper =
            this.errorMessageWrapper ||
            this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
    
        this.errorMessage =
            this.errorMessage ||
            this.errorMessageWrapper.querySelector(".product-form__error-message");
    
        if (errorMessage) {
            this.errorMessage.textContent = errorMessage;
            this.errorMessageWrapper.removeAttribute("hidden");
    
            this.errorMessageWrapper.style.opacity = "1";
    
            setTimeout(() => {
                this.errorMessageWrapper.style.opacity = "0";
                setTimeout(() => {
                    this.errorMessageWrapper.setAttribute("hidden", true);
                }, 500);
            }, 3000);
        } else {
            this.errorMessageWrapper.setAttribute("hidden", true);
        }
      }
    }
  );
}



// second
document.addEventListener('DOMContentLoaded', function () {
  if (!document.body.classList.contains('template_product')) return;
  const main = document.querySelector('main');
  const infoWrapper = document.querySelector('.product_info_related_footer');
  const infoWrapperr = document.querySelector('.main_section_footer');
  const infowrap = document.querySelector('.product__info-wrapper.grid__item');
  const relatedProducts = document.querySelector('.related-products-grid');
  const related = relatedProducts.closest("section");
  const header = document.querySelector('.header');
  const headerwrap = document.querySelector('.header-wrapper');
  const logo = document.querySelector('.header__heading-link');
  const logoicon = document.querySelector('.layout-catalog-logo-icon');
  const ftr = document.querySelector(".shopify-section-group-footer-group");
  const productSlider = document.querySelector(".product_slider_images");
  const image = document.querySelector('.product_otherinfo__image');
  const imagesSelector = document.querySelector(".product-detail-images__image-bar");
  const share = document.querySelector("header .share-button");
  const prevCol = document.querySelector(".related-products_prev-col-small");
  
  let startY = 0;
  let currentY = 0;
  let translateY = -30;
  let isScrollingEnabled = false;
  let isDragging = false;
  
  
  if (window.matchMedia('(max-width: 749px)').matches) {
    const allscrollTriggers = document.querySelectorAll(".trigger_touch_move");
    Array.from(allscrollTriggers).forEach(trigger=>{
      trigger.addEventListener('touchstart', handleTouchStart, false);
      trigger.addEventListener('touchmove', handleTouchMove, false);
      trigger.addEventListener('wheel', e=>e.preventDefault(), false);
      trigger.addEventListener('scroll', e=>e.preventDefault(), false);
      trigger.addEventListener('touchend', handleTouchEnd, false);
    })

    productSlider.addEventListener('touchstart', handleTouchStart, false);
    productSlider.addEventListener('touchend', handleTouchEnd, false);

    var liElements = document.querySelectorAll('.product-detail-images__image-barone li');
    var lastOccurrence = {};

    liElements.forEach(function(li) {
        var thumbnailAlt = li.getAttribute('thumbnail-alt');
        if (thumbnailAlt) {
            lastOccurrence[thumbnailAlt] = li;
        }
    });

    Object.keys(lastOccurrence).forEach(function(thumbnailAlt) {
        lastOccurrence[thumbnailAlt].classList.add('last');
    });

    enableLastImageBarItemEvents();
  }

  function enableLastImageBarItemEvents() {
    const lastImageBarItem = document.querySelectorAll('.product-detail-images__image-barone li.last');
    Array.from(lastImageBarItem).forEach(imgtrigger => {
      imgtrigger.addEventListener('touchstart', handleTouchStart, false);
      imgtrigger.addEventListener('touchmove', handleTouchMove, false);
      imgtrigger.addEventListener('wheel', e => e.preventDefault(), false);
      imgtrigger.addEventListener('scroll', e => e.preventDefault(), false);
      imgtrigger.addEventListener('touchend', handleTouchEnd, false);
    });
  }

  function disableLastImageBarItemEvents() {
    const lastImageBarItem = document.querySelectorAll('.product-detail-images__image-barone li.last');
    Array.from(lastImageBarItem).forEach(imgtrigger => {
      imgtrigger.removeEventListener('touchstart', handleTouchStart, false);
      imgtrigger.removeEventListener('touchmove', handleTouchMove, false);
      imgtrigger.removeEventListener('wheel', e => e.preventDefault(), false);
      imgtrigger.removeEventListener('scroll', e => e.preventDefault(), false);
      imgtrigger.removeEventListener('touchend', handleTouchEnd, false);
    });
  }

  function handleTouchStart(event) {
    if (!event.touches || event.touches.length === 0) return;
    const touch = event.touches[0];
    startY = touch.clientY;
    isDragging = false;
  }

  function handleTouchMove(event) {
    if (!event.touches || event.touches.length === 0) return;
    const touch = event.touches[0];
    currentY = touch.clientY;
    const distance = currentY - startY;
    
    if (Math.abs(distance) > 10) {
      isDragging = true;
    }

    const isAtTop = infoWrapper.scrollTop === 0;
    if (!isAtTop && distance > 0) {
        return;
    }
    
    if (distance < -50) {
      const userAgent = navigator.userAgent;
      const isInstagramBrowser = /Instagram/i.test(userAgent);
      const isIOS = /iPhone|iPad|iPod/i.test(userAgent);
      const isAndroid = /Android/i.test(userAgent);
      if (isInstagramBrowser) {
        // translateY = isIOS ? -390 : -400;
        // const viewportHeight = window.innerHeight;
        translateY = -productSlider.clientHeight + 104;
      } else {
      translateY = -productSlider.clientHeight + 104;
      }
      infoWrapper.style.overflowY = 'auto';
      infoWrapper.style.overscrollBehavior = 'none';
      image.style.pointerEvents = 'none';
      isScrollingEnabled = true;
      logoicon.style.display = 'block';
      logo.style.maxHeight = '80px';
      logo.style.height = '80px';
      logo.style.overflow = 'hidden';
      logo.style.transition = 'height 500ms ease-in-out, max-height 500ms ease-in-out';
      header.style.minHeight = '105px';
      header.style.height = '105px';
      headerwrap.style.minHeight = '105px';
      headerwrap.style.height = '105px';
      header.style.background = 'linear-gradient(180deg, rgba(0, 0, 0, 0.35) 0%, rgba(0, 0, 0, 0) 100%), rgba(255, 255, 255, 0.8)';
      header.style.transition = 'background 500ms ease-in-out, height 500ms ease-in-out, min-height 500ms ease-in-out, max-height 500ms ease-in-out';
      image.style.opacity = '1';
      imagesSelector.style.opacity = '0';
      imagesSelector.style.visibility = 'hidden';
      imagesSelector.style.transition = 'opacity 0s, visibility 0s 0.0s';
      share.style.opacity = '1';
      share.style.pointerEvents = 'auto';
      if (prevCol) {
        prevCol.classList.add("nav-hidden");
      }
      // event.preventDefault();
    } else if (distance > 50 && isAtTop) {
      translateY = -30;
      infoWrapper.style.overflowY = 'hidden';
      isScrollingEnabled = false;
      header.style.minHeight = '48px';
      header.style.height = '48px';
      headerwrap.style.minHeight = '48px';
      headerwrap.style.height = '48px';
      headerwrap.style.transition = 'background 500ms ease-in-out, height 500ms ease-in-out, min-height 500ms ease-in-out, max-height 500ms ease-in-out';
      header.style.transition = 'background 500ms ease-in-out, height 500ms ease-in-out, min-height 500ms ease-in-out, max-height 500ms ease-in-out';
      logo.style.maxHeight = '0px';
      logo.style.height = '0px';
      logo.style.overflow = 'hidden';
      logoicon.style.display = 'none';
      image.style.pointerEvents = 'auto';
      share.style.opacity = '0';
      share.style.pointerEvents = 'none';
      header.style.background = 'transparent';
      image.style.opacity = '1';
      // event.preventDefault();
      imagesSelector.style.opacity = '1';
      imagesSelector.style.visibility = 'visible';
      imagesSelector.style.transition = 'opacity 0.5s, visibility 0s 0.5s';
      if (prevCol) {
        prevCol.classList.remove("nav-hidden");
      }
    }

    if (isDragging) {
      // infoWrapper.style.transform = `translateY(${translateY}px)`;
      infoWrapper.style.transform = `translateY(${Math.round(translateY)}px)`;
    }

    if (!isScrollingEnabled ) {
        return event.preventDefault();
    }

    if(!document.querySelector(".scrolled-past-header") && distance > 0 ){
      return event.preventDefault();
    }
    if(document.querySelector(".scrolled-past-header") && distance < -50){
      return event.preventDefault();
    }
  }

  function handleTouchEnd(event) {
    if (!isDragging) {
      return;
    }

    disableLastImageBarItemEvents();
    setTimeout(() => {
      enableLastImageBarItemEvents();
    }, 500);
    
    startY = 0;
    currentY = 0;
  }
});

// Third
// document.addEventListener('DOMContentLoaded', function () {
//   if (!document.body.classList.contains('template_product')) return;

//   const infoWrapper = document.querySelector('.product_info_related_footer');
//   const productSlider = document.querySelector('.product_slider_images');
//   const header = document.querySelector('.header');
//   const headerwrap = document.querySelector('.header-wrapper');
//   const logo = document.querySelector('.header__heading-link');
//   const logoicon = document.querySelector('.layout-catalog-logo-icon');
//   const image = document.querySelector('.product_otherinfo__image');
//   const imagesSelector = document.querySelector(".product-detail-images__image-bar");
//   const share = document.querySelector("header .share-button");
//   const prevCol = document.querySelector(".related-products_prev-col-small");

//   let startY = 0;
//   let currentY = 0;
//   let translateY = -30; // collapsed
//   let dragStartTranslateY = 0;
//   let minTranslateY; // expanded
//   let maxTranslateY = -30;
//   let threshold = 100; // drag threshold
//   let isDragging = false;
//   let isExpanded = false;
//   let allowScrollInside = false;

//   if (window.matchMedia('(max-width: 749px)').matches) {
//     document.addEventListener('touchstart', handleTouchStart, { passive: false });
//     document.addEventListener('touchmove', handleTouchMove, { passive: false });
//     document.addEventListener('touchend', handleTouchEnd, { passive: false });
//   }

//   // ------------------------
//   // 🔹 TOUCH START
//   // ------------------------
//   function handleTouchStart(event) {
//     if (!event.touches?.length) return;
//     const touch = event.touches[0];
//     startY = touch.clientY;
//     dragStartTranslateY = translateY;
//     isDragging = false;
//     allowScrollInside = isExpanded;

//     // Expanded position (top)
//     minTranslateY = -productSlider.clientHeight + 104;
//     infoWrapper.style.transition = "none";
//   }

//   // ------------------------
//   // 🔹 TOUCH MOVE
//   // ------------------------
//   function handleTouchMove(event) {
//     if (!event.touches?.length) return;
//     const touch = event.touches[0];
//     currentY = touch.clientY;
//     const distance = currentY - startY;

//     if (isExpanded) {
//       const atTop = infoWrapper.scrollTop <= 0;
//       const atBottom = infoWrapper.scrollTop + infoWrapper.clientHeight >= infoWrapper.scrollHeight;

//       if ((!atTop && distance > 0) || (!atBottom && distance < 0)) {
//         return; // normal scroll inside
//       }

//       if (atTop && distance > 10) {
//         // start collapsing
//         isDragging = true;
//         translateY = dragStartTranslateY + distance;
//         translateY = Math.min(maxTranslateY, translateY);
//         infoWrapper.style.transform = `translateY(${translateY}px)`;
//         updateHeaderHeight(translateY);
//         event.preventDefault();
//         return;
//       }
//       return;
//     }

//     if (Math.abs(distance) > 10) isDragging = true;
//     if (!isDragging) return;

//     translateY = dragStartTranslateY + distance;
//     translateY = Math.min(maxTranslateY, Math.max(minTranslateY, translateY));
//     infoWrapper.style.transform = `translateY(${translateY}px)`;
//     updateHeaderHeight(translateY);
//     event.preventDefault();
//   }

//   // ------------------------
//   // 🔹 TOUCH END
//   // ------------------------
//   function handleTouchEnd() {
//     if (!isDragging) return;
//     isDragging = false;
//     infoWrapper.style.transition = "transform 0.35s ease";
//     const movedDistance = translateY - dragStartTranslateY;

//     if (movedDistance < -threshold) {
//       // expand
//       translateY = minTranslateY;
//       expandFooter();
//     } else if (movedDistance > threshold) {
//       // collapse
//       translateY = maxTranslateY;
//       collapseFooter();
//     } else {
//       // snap back
//       translateY = dragStartTranslateY;
//     }

//     infoWrapper.style.transform = `translateY(${translateY}px)`;
//     updateHeaderHeight(translateY, true);
//   }

//   // ------------------------
//   // 🔹 HEADER FOLLOW EFFECT
//   // ------------------------
//   function updateHeaderHeight(translateY, snap = false) {
//     const totalRange = maxTranslateY - minTranslateY;
//     const currentRange = translateY - minTranslateY;
//     const progress = Math.min(1, Math.max(0, currentRange / totalRange)); // 0 = expanded, 1 = collapsed

//     const targetHeight = 105 - (105 - 48) * progress; // map range 105 -> 48
//     const logoHeight = 80 - (80 * progress);

//     header.style.height = `${targetHeight}px`;
//     headerwrap.style.height = `${targetHeight}px`;
//     logo.style.height = `${logoHeight}px`;
//     logo.style.maxHeight = `${logoHeight}px`;

//     if (snap) {
//       header.style.transition = "height 0.35s ease";
//       headerwrap.style.transition = "height 0.35s ease";
//       logo.style.transition = "height 0.35s ease";
//     } else {
//       header.style.transition = "none";
//       headerwrap.style.transition = "none";
//       logo.style.transition = "none";
//     }
//   }

//   // ------------------------
//   // 🔹 EXPAND/COLLAPSE STATES
//   // ------------------------
//   function expandFooter() {
//     infoWrapper.style.overflowY = "auto";
//     infoWrapper.style.overscrollBehavior = "contain";
//     infoWrapper.style.touchAction = "pan-y";
//     infoWrapper.scrollTop = 0;
//     isExpanded = true;
//     expandHeaderView();
//   }

//   function collapseFooter() {
//     infoWrapper.style.overflowY = "hidden";
//     infoWrapper.scrollTop = 0;
//     isExpanded = false;
//     collapseHeaderView();
//   }

//   // ------------------------
//   // 🔹 HEADER STATE CHANGES
//   // ------------------------
//   function expandHeaderView() {
//     logoicon.style.display = 'block';
//     share.style.opacity = '1';
//     share.style.pointerEvents = 'auto';
//     header.style.background =
//       'linear-gradient(180deg, rgba(0,0,0,0.35) 0%, rgba(0,0,0,0) 100%), rgba(255,255,255,0.8)';
//     image.style.pointerEvents = 'none';
//     imagesSelector.style.opacity = '0';
//     imagesSelector.style.visibility = 'hidden';
//     if (prevCol) prevCol.classList.add('nav-hidden');
//   }

//   function collapseHeaderView() {
//     logoicon.style.display = 'none';
//     share.style.opacity = '0';
//     share.style.pointerEvents = 'none';
//     header.style.background = 'transparent';
//     image.style.pointerEvents = 'auto';
//     imagesSelector.style.opacity = '1';
//     imagesSelector.style.visibility = 'visible';
//     if (prevCol) prevCol.classList.remove('nav-hidden');
//   }
// });










document.addEventListener("DOMContentLoaded", () => {
  if (!document.body.classList.contains('template_product')) return;
  if (window.innerWidth < 749) {
    const relatedProducts = document.querySelector('.related-products-grid');
    const related = relatedProducts?.closest("section");
    const footerProducts = document.querySelector('.footer');
    const footer = footerProducts?.closest(".shopify-section");

    const productInfoWrapper = document.querySelector(".product__info-wrapper");

    if (productInfoWrapper && related && footer) {
      productInfoWrapper.insertAdjacentElement("afterend", related);
      related.insertAdjacentElement("afterend", footer);
    }
  }
});




document.addEventListener("DOMContentLoaded", function () {
    const header = document.querySelector(".header");
    const scrollContainer = document.querySelector(".product-detail-images__image-barone ul");

    if (!header || !scrollContainer) return;

    let scrollTimeout;

    scrollContainer.addEventListener("scroll", function () {
        const scrollTop = scrollContainer.scrollTop;
        const scrollHeight = scrollContainer.scrollHeight;
        const containerHeight = scrollContainer.clientHeight;

        const isAtBottom = scrollTop + containerHeight >= scrollHeight - 1;

        if (scrollTop === 0 || isAtBottom) {
            header.classList.remove("image-scroll");
        } else {
            header.classList.add("image-scroll");
        }

        clearTimeout(scrollTimeout);

        scrollTimeout = setTimeout(() => {
            header.classList.remove("image-scroll");
        }, 500);
    });
});



// // ========== SCROLL STATE PRESERVATION INTEGRATION ==========

// (function () {
//   const STATE_KEY_PREFIX = 'collection-scroll-state:';
//   const currentKey = STATE_KEY_PREFIX + location.pathname + location.search;

//   if ('scrollRestoration' in history) {
//     try { history.scrollRestoration = 'manual'; } catch (e) {}
//   }

//   function getActiveFilters() {
//     try {
//       const filters = {};
//       document.querySelectorAll('[data-filter-name]').forEach(el => {
//         const name = el.getAttribute('data-filter-name');
//         if (!name) return;
//         if (el.matches('input[type="checkbox"]')) {
//           filters[name] = Array.from(document.querySelectorAll(`input[data-filter-name="${name}"]:checked`)).map(i => i.value);
//         } else if (el.matches('select')) {
//           filters[name] = el.value;
//         } else {
//           filters[name] = el.classList.contains('active') ? true : null;
//         }
//       });
//       return filters;
//     } catch (e) {
//       return null;
//     }
//   }

//   function saveState() {
//     const payload = {
//       scrollY: window.scrollY || window.pageYOffset || 0,
//       timestamp: Date.now(),
//       gridMode: document.documentElement.dataset.gridMode || null,
//       activeFilters: getActiveFilters()
//     };
//     sessionStorage.setItem(currentKey, JSON.stringify(payload));
//     try {
//       history.replaceState(Object.assign({}, history.state || {}, { collectionScrollState: payload }), document.title);
//     } catch (e) {}
//   }

//   function restoreUIState(state) {
//     if (!state) return;
//     if (state.gridMode) {
//       document.documentElement.dataset.gridMode = state.gridMode;
//       if (typeof applyGridMode === 'function') applyGridMode(state.gridMode);
//     }
//     if (state.activeFilters && typeof applyFilters === 'function') applyFilters(state.activeFilters);
//   }

//   function restoreScroll(state) {
//     if (!state || typeof state.scrollY !== 'number') return;
//     return new Promise(resolve => {
//       const gridSelector = '.collection__grid, .product-grid, [data-collection-grid]';
//       let tries = 0;
//       const tryScroll = () => {
//         const el = document.querySelector(gridSelector);
//         if (el || tries > 30) {
//           requestAnimationFrame(() => {
//             setTimeout(() => {
//               window.scrollTo(0, state.scrollY);
//               restoreUIState(state);
//               resolve(true);
//             }, 60);
//           });
//           clearInterval(int);
//         }
//         tries++;
//       };
//       const int = setInterval(tryScroll, 50);
//       tryScroll();
//     });
//   }

//   function attachLinkListeners() {
//     const productLinkSelector = 'a[href*="/products/"]';
//     document.querySelectorAll(productLinkSelector).forEach(a => {
//       if (a.dataset._savedHandler) return;
//       a.addEventListener('click', () => saveState(), { capture: true });
//       a.dataset._savedHandler = '1';
//     });
//   }

//   window.addEventListener('pagehide', saveState, { passive: true });
//   document.addEventListener('visibilitychange', () => {
//     if (document.visibilityState === 'hidden') saveState();
//   });
//   let saveTimer = null;
//   window.addEventListener('scroll', () => {
//     if (saveTimer) clearTimeout(saveTimer);
//     saveTimer = setTimeout(saveState, 250);
//   }, { passive: true });

//   window.addEventListener('pageshow', ev => {
//     const fromHistory = (history.state && history.state.collectionScrollState) ? history.state.collectionScrollState : null;
//     let fromSession = null;
//     try {
//       const raw = sessionStorage.getItem(currentKey);
//       fromSession = raw ? JSON.parse(raw) : null;
//     } catch (e) {}
//     const candidate = fromHistory || fromSession;
//     if (candidate) restoreScroll(candidate).catch(()=>{});
//     attachLinkListeners();
//   });

//   window.addEventListener('popstate', ev => {
//     const st = (ev.state && ev.state.collectionScrollState) ? ev.state.collectionScrollState : null;
//     let sess = null;
//     try {
//       const raw = sessionStorage.getItem(currentKey);
//       sess = raw ? JSON.parse(raw) : null;
//     } catch (e) {}
//     const candidate = st || sess;
//     if (candidate) restoreScroll(candidate).catch(()=>{});
//     attachLinkListeners();
//   });

//   attachLinkListeners();

//   // Optional clear on full reloads
//   // if (performance && performance.getEntriesByType) {
//   //   const nav = performance.getEntriesByType('navigation')[0];
//   //   if (nav && nav.type === 'reload') sessionStorage.removeItem(currentKey);
//   // }

//   // Expose helper for Ajaxinate to call after loading new items
//   window.collectionScrollRestoreHelpers = {
//     saveState,
//     restoreState: async () => {
//       try {
//         const raw = sessionStorage.getItem(currentKey);
//         const st = raw ? JSON.parse(raw) : null;
//         if (st) await restoreScroll(st);
//       } catch (e) {}
//     },
//     attachLinkListeners
//   };
// })();
